
import { Component, Mixins } from 'vue-property-decorator'
import IconsMixin from '@/mixins/IconsMixin.vue'
import AuthMixin from '@/mixins/AuthMixin.vue'
import { Company, CompanyCollection, CompanyTypeEnum } from '@/firestore'

@Component
export default class RestaurantList extends Mixins(IconsMixin, AuthMixin) {
  public data: Company[] = []
  public headers = [
    {text: 'Name', value: 'name'},
    {text: 'Status', value: 'status'}
  ]
  public search = ''

  public async mounted() {
    const collection = new CompanyCollection((await this.$firebase).firestore())
    this.data = collection.watchCompaniesByAdminCompany(this.userCompany.id)
  }

  public async viewRestaurant(restaurant: Company) {
    await this.$router.push({name: 'restaurant-edit', params: {id: restaurant.id}})
  }
}
